import { useEffect, useMemo, useState } from 'react';
import Invoice from 'shared/db/services/Invoice';

import { databaseValidation } from '@/services/databaseValidation';
import { FirebaseImagesService } from '@/services/firebase/images';
import { dbServiceLogger } from '@/services/logger/logger';

import { useDatabase } from './useDatabase';

export function useMonthlyInvoicesCount() {
    const db = useDatabase();
    const [monthlyInvoicesCount, setMonthlyInvoicesCount] = useState(0);

    const invoiceService = useMemo(
        () =>
            new Invoice({
                database: db.getDatabase(),
                imageService: new FirebaseImagesService(),
                logger: dbServiceLogger,
                validation: databaseValidation,
            }),
        [db],
    );

    useEffect(() => {
        const subscription = invoiceService
            .observeCreatedThisMonth()
            .subscribe(setMonthlyInvoicesCount);

        return () => {
            subscription.unsubscribe();
        };
    }, [invoiceService]);

    return monthlyInvoicesCount;
}
